import React from 'react';
import PropTypes from 'prop-types';

import './Tags.scss';

const Tags = (props) => (
  <div className="tags-wrapper">
    {props.tags.map((tag, i) => (
      <div
        key={i}
        className="tag"
        style={{
          backgroundColor: tag.backgroundColor,
          color: tag.textColor
        }}>
        {tag.label}
      </div>
    )
    )}
  </div>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      backgroundColor: PropTypes.string,
      label: PropTypes.string,
      textColor: PropTypes.string,
    })
  )
};

export default Tags;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Tags/Tags.js